import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHub = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_26813_9729)",
			children: [/* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip1_26813_9729)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M3.80856 -14.4257C3.30527 -15.848 1.69475 -16.5243 0.349607 -15.8711C-2.41389 -14.523 -4.97149 -12.6931 -7.14478 -10.4926C-12.2966 -5.27621 -15.1333 1.65888 -15.1333 9.03409C-15.1333 16.5158 -12.228 23.5158 -6.95261 28.7553C-4.82508 30.8678 -2.33611 32.6329 0.349607 33.9439C1.69018 34.5971 3.29612 33.9161 3.80398 32.4985C4.23864 31.2709 3.69875 29.9043 2.53661 29.3391C0.349607 28.2736 -1.68184 26.8328 -3.41589 25.1094C-7.71669 20.8428 -10.0821 15.1353 -10.0821 9.03873C-10.0821 3.02552 -7.7716 -2.6217 -3.57145 -6.87449C-1.79622 -8.67196 0.290129 -10.1637 2.54577 -11.2663C3.70332 -11.8361 4.24322 -13.2027 3.80856 -14.4257Z",
						fill: "url(#paint0_linear_26813_9729)"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M22.1361 -8.41725C21.2315 -8.87905 20.1361 -8.68502 19.4185 -7.95546L18.8574 -7.385C18.1437 -6.65932 18.388 -5.44467 19.3116 -5.03721C23.2124 -3.31031 26.3422 -0.287278 28.2811 3.41875C29.2239 5.21937 27.9643 7.39254 25.9567 7.39254C24.9758 7.39254 24.0788 6.84148 23.6208 5.96058C21.2697 1.45125 16.4757 -1.54073 11.0253 -1.17983C4.49477 -0.745198 -0.806776 4.58683 -1.29533 11.2228C-1.87548 19.1276 4.26195 25.7209 11.9108 25.7209C17.0025 25.7209 21.4223 22.7987 23.6361 18.5145C24.0865 17.6452 24.9872 17.1175 25.9567 17.1175C27.9376 17.1175 29.2315 19.2596 28.304 21.0408C26.5178 24.4829 23.701 27.343 20.1933 29.1242C19.4681 29.4929 18.8689 30.463 18.8689 31.2896C18.8689 32.772 20.3918 33.7771 21.7086 33.1368C29.5407 29.3338 34.6667 21.2077 34.6667 12.2511C34.6667 3.46143 29.7277 -4.52884 22.1361 -8.41725Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("g", {
						clipPath: "url(#clip2_26813_9729)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M7.54189 13.625C6.71022 13.625 6.24199 12.6689 6.7519 12.0118L11.105 6.40316C11.397 6.02686 12 6.23338 12 6.70972V10.375H16.458C17.2897 10.375 17.7579 11.3311 17.248 11.9881L12.8949 17.5969C12.6029 17.9732 12 17.7666 12 17.2902V13.625H7.54189Z",
							fill: "url(#paint1_linear_26813_9729)"
						})
					})
				]
			}), /* @__PURE__ */ _jsx("rect", {
				x: .375,
				y: .375,
				width: 23.25,
				height: 23.25,
				rx: 11.625,
				stroke: "#ECECEC",
				strokeWidth: .75
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_26813_9729",
				x1: -5.28367,
				y1: 9.03289,
				x2: 53.2819,
				y2: 9.03289,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#003399" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#06D0DB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_26813_9729",
				x1: 3.75,
				y1: 12,
				x2: 19.125,
				y2: 12,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#003399" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#06D0DB"
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_26813_9729",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 24,
					height: 24,
					rx: 12,
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_26813_9729",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 24,
					height: 24,
					rx: 12,
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip2_26813_9729",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgHub);
export { ForwardRef as ReactComponent };
